/* eslint-disable */

import React, { useEffect, useState } from "react";

import RaindropInputTextArea from "../../../ui-components/raindrop-input-text-area/raindrop-input-text-area.tsx";
import JSONBlob from "../../../ui-components/json-blob/json-blob.tsx";
import {
  fetchOrganisationDetailGet,
  fetchOrganisationDetailPost,
  fetchOrganisationLogoPost,
} from "../../../services/api-raindrop.js";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropInputFile from "../../../ui-components/raindrop-input-file/raindrop-input-file.tsx";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import Spacer from "../../../ui-components/spacer/spacer.js";

const UpdateOrganisationForm = ({ organisation }) => {
  return (
    <RaindropCard>
      <div className="flex flex-col text-left w-full">
        <h1 className="text-2xl font-bold">Organisation Details</h1>
        <p className="dark:text-color-dark-text-secondary text-color-text-secondary">
          Update your organisation's name and website.
        </p>
      </div>
      <RaindropInput
        label="Name"
        value={organisation.name}
        onChange={(e) => {
          console.log("Update name");
        }}
        isShowLabel={true}
        isEditing={false}
      />
      <RaindropInput
        label="Website"
        value={organisation.website}
        onChange={(e) => {
          console.log("Update website");
        }}
        isShowLabel={true}
        icon=""
        isEditing={false}
      />
      <RaindropInput
        label="Description Short"
        value={organisation.description_short}
        onChange={(e) => console.log("Update description short")}
        isShowLabel={true}
        icon=""
        isEditing={false}
      />
    </RaindropCard>
  );
};
const UpdateDetailsForm = ({ currentOrganisationUser }) => {
  return (
    <RaindropCard>
      <div className="flex flex-col text-left gap-2">
        <h1 className="text-2xl font-bold">Private Details</h1>
        <p className="dark:text-color-dark-text-secondary text-color-text-secondary">
          Update your personal and organisational details. These will be
          private.
        </p>
      </div>
      <RaindropInput
        label="Email"
        value={currentOrganisationUser.email}
        onChange={(e) => {
          console.log("Update name");
        }}
        isEditing={false}
      />
      <RaindropInput
        label="Phone"
        value={currentOrganisationUser.phone}
        onChange={(e) => {
          console.log("Update website");
        }}
        isEditing={false}
      />
      <RaindropInput
        label={"name legal"}
        value={currentOrganisationUser.name_legal}
        onChange={(e) => console.log("Update name legal")}
        isEditing={false}
      />
      <RaindropInput
        label="name preferred"
        value={currentOrganisationUser.name_preferred}
        onChange={(e) => console.log("Update name preferred")}
        isEditing={false}
      />
    </RaindropCard>
  );
};

const UpdateDescriptionForm = ({ organisation }) => {
  const [newDescription, setNewDescription] = useState(
    organisation.description
  );

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetchOrganisationDetailGet({ organisationId: organisation.id }).then(
      (orgDetail) => {
        setNewDescription(orgDetail.organisation_detail?.description_long);
      }
    );
  }, [organisation.id]);

  const onSubmit = () => {
    console.log("Update description");
    setIsSubmitting(true);
    fetchOrganisationDetailPost({
      organisationId: organisation.id,
      descriptionLong: newDescription,
    }).finally(() => {
      setIsSubmitting(false);
      console.log("Update description success");
    });
  };

  return (
    <RaindropCard>
      <div className="flex flex-col text-left gap-2">
        <h1 className="text-2xl font-bold ">Public Description</h1>
        <p className="dark:text-color-dark-text-secondary text-color-text-secondary">
          Organisation Details appear on the search page of the Raindrop App.
        </p>
      </div>
      <RaindropInputTextArea
        label="Description"
        value={newDescription}
        onChange={(e) => setNewDescription(e.target.value)}
        icon=""
        maxLength={1000}
      />
      <div className="flex flex-row w-full">
        <Spacer />
        <RaindropButton
          onClick={onSubmit}
          isLoading={isSubmitting}
          title="Update"
        />
      </div>
    </RaindropCard>
  );
};

const UpdateOrganisationIconForm = ({ organisation }) => {
  const [imageUrl, setNewImageUrl] = useState(organisation.logo_url);
  const [file, setFile] = useState();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = (e) => {
    console.log("Update icon");

    if (file == null) {
      console.log("(RD-2141) -- No file Update icon");
      return;
    }

    setIsSubmitting(true);

    fetchOrganisationLogoPost({ organisationId: organisation.id, file: file })
      .then(() => {
        console.log("Update icon success");
      })
      .catch(() => {
        console.log("(RD-4522) - Update icon failed");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <RaindropCard>
      <div className="flex flex-col text-left gap-2">
        <h1 className="text-2xl font-bold ">Update Logo</h1>
        <p className="dark:text-color-dark-text-secondary text-color-text-secondary">
          Logos will appear throughout the app and on activity sheets.
        </p>
      </div>
      <RaindropInputFile
        setImageUrl={setNewImageUrl}
        imageUrl={imageUrl}
        onChange={(e) => setFile(e.target.files[0])}
      />
      <div className="flex flex-row w-full">
        <Spacer />
        <RaindropButton
          onClick={onSubmit}
          isLoading={isSubmitting}
          title={"Update"}
        />
      </div>
    </RaindropCard>
  );
};

const CirrusSettings = ({ organisation, currentOrganisationUser }) => {
  return (
    <div className={`flex flex-col w-full h-full gap-6 max-w-md pb-6`}>
      <div className="text-4xl font-bold">Settings</div>
      <div className="flex flex-col gap-2 h-full ">
        <UpdateOrganisationForm organisation={organisation} />
        <UpdateDetailsForm currentOrganisationUser={currentOrganisationUser} />
        <UpdateDescriptionForm organisation={organisation} />
        <UpdateOrganisationIconForm organisation={organisation} />
      </div>
    </div>
  );
};

export default CirrusSettings;
